import { $ } from "@/plug/Axios";

export default {
  /**
   * 固定资产内容1
   */
  assetContent_assign: {
    /*
     * 分配给员工
     * adminId 员工id (integer query required)
     * id ID (integer query required)
     * reason 分配理由 (string query )
     */
    post: (p, c) => $.post("/api/bms/asset/assetContent/assign", p, c)
  },
  assetContent_exportForComputerPhone: {
    /*
     * 导出-电脑手机列表
     */
    get: (p, c) =>
      $.get("/api/bms/asset/assetContent/exportForComputerPhone", p, c)
  },
  assetContent_exportForPhoneNumber: {
    /*
     * 导出-手机号码列表
     */
    get: (p, c) =>
      $.get("/api/bms/asset/assetContent/exportForPhoneNumber", p, c)
  },
  assetContent_listComputerPhoneRecord: {
    /*
     * 根据行id查询手机电脑使用记录
     * id ID (integer query required)
     */
    get: (p, c) =>
      $.get("/api/bms/asset/assetContent/listComputerPhoneRecord", p, c)
  },
  assetContent_listForComputerPhone: {
    /*
     * 电脑手机列表
     */
    get: (p, c) =>
      $.get("/api/bms/asset/assetContent/listForComputerPhone", p, c)
  },
  assetContent_listForPhoneNumber: {
    /*
     * 手机号码列表
     */
    get: (p, c) => $.get("/api/bms/asset/assetContent/listForPhoneNumber", p, c)
  },
  assetContent_listPhoneNumberRecord: {
    /*
     * 根据行id查询号码使用记录
     * id ID (integer query required)
     */
    get: (p, c) =>
      $.get("/api/bms/asset/assetContent/listPhoneNumberRecord", p, c)
  },
  assetContent_remove: {
    /*
     * 删除
     * id ID (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/asset/assetContent/remove", p, c)
  },
  assetContent_save: {
    /*
     * 添加编辑
     * belong 所属：公司|易点云|个人 (string query )
     * brand 品牌 (string query )
     * category 分类：电脑|手机|手机号码 (string query )
     * description 其他描述 (string query )
     * endTime 报废时间 (string query )
     * id  (integer query )
     * identificationCode 唯一编号 (string query )
     * model 型号 (string query )
     * operator 运营商 (string query )
     * remark 备注 (string query )
     * startTime 开始使用时间 (string query )
     * type 类型（台式机|笔记本） (string query )
     */
    post: (p, c) => $.post("/api/bms/asset/assetContent/save", p, c)
  },
  assetContent_upload: {
    /*
     * 导入
     * excelFile excelFile (file formData required)
     * type 类型: 1电脑手机 2手机号码 (integer query required)
     */
    post: (p, c) => $.post("/api/bms/asset/assetContent/upload", p, c)
  },

  /**
   * 员工固定资产
   */
  assetEmployee_confirm: {
    /*
     * 确认
     * id 行ID (integer query required)
     */
    post: (p, c) => $.post("/api/bms/asset/assetEmployee/confirm", p, c)
  },
  assetEmployee_getEmployeeAssetDetailVO: {
    /*
     * 员工列表点击查看详情
     * id ID (integer query required)
     * statusList 状态下拉列表 (array query )
     */
    get: (p, c) =>
      $.get("/api/bms/asset/assetEmployee/getEmployeeAssetDetailVO", p, c)
  },
  assetEmployee_listEmployeeComputerPhone: {
    /*
     * 电脑手机列表-内部管理
     */
    get: (p, c) =>
      $.get("/api/bms/asset/assetEmployee/listEmployeeComputerPhone", p, c)
  },
  assetEmployee_listEmployeeForAsset: {
    /*
     * 员工列表-人事平台
     */
    get: (p, c) =>
      $.get("/api/bms/asset/assetEmployee/listEmployeeForAsset", p, c)
  },
  assetEmployee_listEmployeePhoneNumber: {
    /*
     * 手机号码列表-内部管理
     */
    get: (p, c) =>
      $.get("/api/bms/asset/assetEmployee/listEmployeePhoneNumber", p, c)
  },
  assetEmployee_sync: {
    /*
     * 同步
     * instanceId instanceId (string query required)
     */
    post: (p, c) => $.post("/api/bms/asset/assetEmployee/sync", p, c)
  },
  assetEmployee_transfer: {
    /*
     * 转让分配
     * adminId 员工id (integer query required)
     * dingDepartmentId 钉钉部门id (integer query required)
     * id 行ID (integer query required)
     * reason 转让理由 (string query required)
     */
    post: (p, c) => $.post("/api/bms/asset/assetEmployee/transfer", p, c)
  }
};
